import {Component, trigger, transition, style, animate} from '@angular/core';
import {Router} from '@angular/router';

import {TokenManagerService} from './shared/services/token-login.service';
import {ToasterConfig} from 'angular2-toaster';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({transform: 'translateX(100%)'}),
        animate('250ms', style({transform: 'translateX(0)'}))
      ]),
      transition(':leave', [
        style({transform: 'translateX(0)'}),
        animate('250ms', style({transform: 'translateX(100%)'}))
      ])
    ])
  ]
})
export class AppComponent {
  menu = false;

  toasterconfig = new ToasterConfig({animation: 'fade'});

  constructor(private tokenManagerService: TokenManagerService, private router: Router) {
  }

  toggleMenu(event) {
    event.stopPropagation();
    this.menu = !this.menu;
    if (this.menu) {
      document.body.style.overflowX = 'hidden';
    } else {
      setTimeout(() => {
        document.body.style.overflowX = 'auto';
      }, 500);
    }
  }

  closeMenu() {

    this.menu = false;

    setTimeout(() => {
      document.body.style.overflowX = 'auto';
    }, 500);

  }


  logout() {
    this.tokenManagerService.logout();
    this.router.navigate(['Login']);
  }

  menuInnerClick(event) {
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/app.component.ts